import script from "./InputAmountPerformanceNewWeb.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAmountPerformanceNewWeb.vue?vue&type=script&setup=true&lang=ts"

import "./InputAmountPerformanceNewWeb.vue?vue&type=style&index=0&id=3bc1fdf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc1fdf4"]])

export default __exports__